import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import useMediaQuery from '@mui/material/useMediaQuery';

import { setWebsocketOrgId } from '../../../store/pages';
import useSensor from '../../../store/hooks/useSensor';
import usePageId from '../../../store/hooks/usePageId';
import useTimeseriesData from '../../../store/hooks/useTimeseriesData';

import TabBar, {
  ANALYSIS,
  CONFIGURATION,
  DASHBOARD,
} from '../../../components/tab/TabBar';
import SensorDashboard from './Dashboard';
import Analysis from './Analysis';
import AlarmConfigurationPage from '../../../components/AlarmConfigurationPage';
import useTab from '../../../store/hooks/useTab';

const PAGE = 'sensor';
const TABS = [DASHBOARD, ANALYSIS, CONFIGURATION];

export default function Sensor() {
  const dispatch = useDispatch();
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down('md'));
  const { id } = useSelector((state) => state.pages.sensor);
  const sensor = useSensor(id);
  usePageId(id, PAGE);
  useTimeseriesData(id);

  const [tabs, setTabs] = useState([DASHBOARD, CONFIGURATION]);
  const selectedTab = useTab(tabs);

  useEffect(() => {
    if (sensor?.org_id) dispatch(setWebsocketOrgId(sensor.org_id));
  }, [sensor?.org_id, dispatch]);

  useEffect(() => {
    if (isMobile) setTabs([DASHBOARD, CONFIGURATION]);
    else setTabs(TABS);
  }, [isMobile]);

  return (
    <TabBar tabs={tabs} selectedTab={selectedTab}>
      <SensorDashboard tab={DASHBOARD} />
      <Analysis tab={ANALYSIS} />
      <AlarmConfigurationPage tab={CONFIGURATION} resource={sensor} />
    </TabBar>
  );
}
